import { render, staticRenderFns } from "./ModalImpressaoBotao.vue?vue&type=template&id=3325e63e&scoped=true&"
import script from "./ModalImpressaoBotao.vue?vue&type=script&lang=js&"
export * from "./ModalImpressaoBotao.vue?vue&type=script&lang=js&"
import style0 from "./ModalImpressaoBotao.vue?vue&type=style&index=0&id=3325e63e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3325e63e",
  null
  
)

export default component.exports